import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import './styles.scss';

const LinkedTabs = ({ linkedTabItems, isDisabled }) => {
  const mappedlinkedTabItems = linkedTabItems.map((linkedTabItem, index) => {
    const { onClick, onClickParams, linkPath, linkText, active } =
      linkedTabItem;
    const key = `${linkPath}${index}`;
    return (
      <Link
        tabIndex={0}
        to={linkPath}
        className={`linked-tabs__link ${classNames({
          active,
          disabled: isDisabled,
        })}`}
        onClick={() => !active && onClick(onClickParams)}
        key={key}
        disabled={isDisabled}
      >
        {linkText}
      </Link>
    );
  });
  return <div className="linked-tabs">{mappedlinkedTabItems}</div>;
};

LinkedTabs.propTypes = {
  linkedTabItems: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      onClickParams: PropTypes.any,
      linkPath: PropTypes.string,
      linkText: PropTypes.node,
      active: PropTypes.bool,
    }),
  ),
  isDisabled: PropTypes.bool,
};

LinkedTabs.defaultProps = {
  linkedTabItems: [],
  isDisabled: false,
};

export default LinkedTabs;
